export default "__VITE_ASSET__Ccyr0ls2__"